export default "/048cb1f2b29308e18768c65cfd51e426596a830c/9efedd6f8d84b8cf11b1862201b47d04.svg";